'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');

function lastName() {
    return {
        id: 'lastName',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-lastname',
        properties: {
            placeholder: magicCommon.translate('sign-up-step-two.last-name.placeholder'),
        },
        validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: magicCommon.translate('sign-up-step-two.last-name.required-error'),
            },
            {
                name: 'min-length',
                fn: magicFormBuilder.minLength(2),
                message: magicCommon.translate('sign-up-step-two.last-name.min-length-error'),
            },
            {
                name: 'max-length',
                fn: magicFormBuilder.maxLength(40),
                message: magicCommon.translate('sign-up-step-two.last-name.max-length-error'),
            },
            {
                name: 'contains-letter',
                fn: magicFormBuilder.containsLetter,
                message: magicCommon.translate('sign-up-step-two.last-name.contains-letter-error'),
            },
        ],
        converter: function (formValue) {
            return {
                surname: formValue.lastName.value,
            };
        },
    };
}

exports.lastName = lastName;
